import QuoteTagChip from './QuoteTag'

export * from './QuoteTag'
export default QuoteTagChip
